<!--
 * @Author: your name
 * @Date: 2020-12-25 16:12:53
 * @LastEditTime: 2021-01-05 01:56:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/product/detail/components/SkuActionSheet/index.vue
-->
<template>
  <div :class="{ num_none: !showNum }" class="con font0 text_left">
    <van-sku
      v-model="show"
      :sku="skuTree"
      :goods="goodsPic"
      :hide-quota-text="true"
      :hide-stock="true"
      :initial-sku="initialSku"
      :stepper-title="'数量'"
      @stepper-change="stepperChange"
      @sku-selected="skuPropSelected"
    >
      <template #sku-actions="props">
        <div class="sku_btn">
          <div
            v-if="bottomBtnSwitch === 'skuSelect'"
            class="bottom_btn font14 font_weight500 line_height_20 colo087"
          >
            <div
              :class="isAdd(props.selectedSkuComb) ? 'add_car' : 'none_add'"
              @click="addCart(props)"
            >
              加入购物车
            </div>
            <div class="go_now colof" @click="goNow(props)">
              立即购买
            </div>
          </div>
          <div
            v-if="bottomBtnSwitch !== 'skuSelect'"
            class="bottom_btn1 font14 font_weight500 line_height_20 colof text_center"
          >
            <div class="btn text_center" @click="sure(props)">
              确定
            </div>
          </div>
        </div>
      </template>
    </van-sku>
  </div>
</template>
<script>
export default {
  props: {
    bottomBtnSwitch: {
      type: String,
      default: "skuSelect"
    },
    showNum: {
      type: Boolean,
      default: true
    },
    initialSku: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      show: true,
      sku: {
        // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
        // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
        tree: [
          {
            k: "颜色", // skuKeyName：规格类目名称
            k_s: "s1", // skuKeyStr：sku 组合列表（下方 list）中当前类目对应的 key 值，value 值会是从属于当前类目的一个规格值 id
            v: [
              {
                id: "2",
                name: "蓝色",
                imgUrl: "https://img.yzcdn.cn/2.jpg"
                // previewImgUrl: "https://img.yzcdn.cn/2p.jpg"
              }
            ],
            largeImageMode: false //  是否展示大图模式
          },
          {
            k: "规格", // skuKeyName：规格类目名称
            k_s: "s2", // skuKeyStr：sku 组合列表（下方 list）中当前类目对应的 key 值，value 值会是从属于当前类目的一个规格值 id
            v: [
              {
                id: "3", // skuValueId：规格值 id
                name: "红色色", // skuValueName：规格值名称
                imgUrl: "https://img.yzcdn.cn/1.jpg" // 规格类目图片，只有第一个规格类目可以定义图片
                // previewImgUrl: "https://img.yzcdn.cn/1p.jpg" // 用于预览显示的规格类目图片
              },
              {
                id: "4",
                name: "蓝色色",
                imgUrl: "https://img.yzcdn.cn/2.jpg"
                // previewImgUrl: "https://img.yzcdn.cn/2p.jpg"
              }
            ],
            largeImageMode: false //  是否展示大图模式
          }
        ],
        // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
        list: [
          {
            id: 2259, // skuId
            s1: "1", // 规格类目 k_s 为 s1 的对应规格值 id
            s2: "3", // 规格类目 k_s 为 s2 的对应规格值 id
            price: 100, // 价格（单位分）
            stock_num: 110 // 当前 sku 组合对应的库存
          },
          {
            id: 2259, // skuId
            s1: "1", // 规格类目 k_s 为 s1 的对应规格值 id
            s2: "4", // 规格类目 k_s 为 s2 的对应规格值 id
            price: 100, // 价格（单位分）
            stock_num: 110 // 当前 sku 组合对应的库存
          },
          {
            id: 2259, // skuId
            s1: "2", // 规格类目 k_s 为 s1 的对应规格值 id
            s2: "3", // 规格类目 k_s 为 s2 的对应规格值 id
            price: 100, // 价格（单位分）
            stock_num: 110 // 当前 sku 组合对应的库存
          },
          {
            id: 2259, // skuId
            s1: "2", // 规格类目 k_s 为 s1 的对应规格值 id
            s2: "4", // 规格类目 k_s 为 s2 的对应规格值 id
            price: 100, // 价格（单位分）
            stock_num: 110 // 当前 sku 组合对应的库存
          }
        ],
        price: "1.00", // 默认价格（单位元）
        stock_num: 227, // 商品总库存
        collection_id: 2261, // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
        none_sku: false, // 是否无规格商品
        messages: [
          {
            // 商品留言
            datetime: "0", // 留言类型为 time 时，是否含日期。'1' 表示包含
            multiple: "0", // 留言类型为 text 时，是否多行文本。'1' 表示多行
            name: "留言", // 留言名称
            type: "text", // 留言类型，可选: id_no（身份证）, text, tel, date, time, email
            required: "1", // 是否必填 '1' 表示必填
            placeholder: "" // 可选值，占位文本
          }
        ],
        hide_stock: false // 是否隐藏剩余库存
      },
      goodsPic: {
        // 默认商品 sku 缩略图
        picture: "https://assets-img.myazstore.com/freshmilk/xiannai.jpg"
      },
      values: {},
      // initialSku: {},
      curNum: 1
    };
  },
  computed: {
    mallretailspu() {
      return this.$store.getters.mallretailspu;
    },
    skuTree() {
      const { skuProps } = this.$store.getters.mallretailspu;
      const { skus } = this.$store.getters.mallretailspu;
      const skuTree = {
        tree: [], //sku列表
        list: [] //sku组合
      };

      let kSList = []; // k_s 集合
      skuProps.forEach(item => {
        let a = [];
        item.values.forEach(i => {
          // console.log(i, "i");
          a.push({
            id: i,
            name: i
          });
        });
        skuTree.tree.push({
          k: item.prop,
          k_s: item.prop,
          v: a
        });
      });
      skuTree.tree.forEach(k => {
        kSList.push(k.k_s);
      });
      for (let list in skus) {
        const item = {
          id: skus[list].id, // skuId
          price: skus[list].storePrice * 100, // 价格（单位分）
          stock_num: skus[list].inStock === 1 ? 9999999 : 0, // 当前 sku 组合对应的库存
          picture: skus[list].attributeImg,
          tradeType: skus[list].tradeType,
          kind: skus[list].kind,
          isCycle: skus[list].isCycle
        };
        kSList.forEach((ks, indexs) => {
          // console.log(ks, "ks");
          item[ks] = list.split(">")[indexs];
          // console.log(item, "item");
        });
        skuTree.list.push(item);
      }
      return skuTree;
    }
    // initialSku() {
    //   let obj = {};
    //   // eslint-disable-next-line no-unused-vars
    //   let chooseSku = {};
    //   this.skuTree.list.forEach(li => {
    //     if (li.id == this.$route.query.skuId) {
    //       chooseSku = JSON.parse(JSON.stringify(li));
    //     }
    //   });
    //   this.skuTree.tree.forEach(tr => {
    //     obj[tr.k] = chooseSku[tr.k];
    //   });
    //   obj.selectedNum = 1;
    //   return obj;
    // }
  },
  watch: {
    show(nVal, oVal) {
      this.show = true;
      this.$emit("closeSheet");
      console.log(nVal, oVal);
    }
  },
  mounted() {
    this.show = true;
    this.goodsPic.picture = this.mallretailspu.thumbnailImg;
  },
  methods: {
    isAdd(props) {
      if (props !== null) {
        return !(
          (props.tradeType === 2 &&
            props.kind === 1 &&
            props.isCycle > 0 &&
            props.isCycle !== null) ||
          (props.tradeType === 2 && props.kind === 2)
        );
      }
      return true;
    },
    addCart(value) {
      this.$emit("addCart", value);
    },
    stepperChange(num) {
      this.curNum = num;
      this.$emit("stepperChange", num);
    },
    skuPropSelected(props) {
      let keys = "";
      for (let k in props.selectedSku) {
        if (props.selectedSku[k]) {
          keys += props.selectedSku[k] + ">";
        }
      }
      for (let sku in this.mallretailspu.skus) {
        if (sku === keys.substring(0, keys.length - 1)) {
          this.goodsPic.picture = this.mallretailspu.skus[sku].attributeImg;
        }
      }
      this.$emit("closeSelectSku", props, this.curNum);
    },
    goNow(value) {
      this.$emit("goNow", value);
    },
    sure(value) {
      if (this.bottomBtnSwitch === "buyNow") {
        this.$emit("goNow", value, this.curNum);
      } else if (this.bottomBtnSwitch === "addCart") {
        this.$emit("addCart", value, this.curNum);
      } else {
        this.values = value;
        this.$emit("sureSelectSku", value, this.curNum);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.example-3d {
  width: 100%;
  // height: 400px;
}

.swiper {
  height: 100%;
  width: 100%;

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 300px;
    height: 300px;
    text-align: center;
    font-weight: bold;
    font-size: 12px;
    background-color: #2c8dfb;
    background-position: center;
    background-size: cover;
    color: #fff;
  }

  .swiper-pagination {
    ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
      background-color: #fff;
    }
  }
}
.con {
  ::v-deep .van-sku-row__item--active {
    color: #bf9264;
  }
  .content {
    background: #fff;
    height: 256px;
    .sku_name {
      margin: 0 12px;
      padding: 12px 0 16px;
      .sku_tags {
        margin-top: 12px;
        display: inline-block;
      }
      .name_name {
        margin-top: 4px;
      }
    }
    .sku_over {
      height: 260px;
      overflow-y: scroll;
    }
    .sku_sku_list {
      margin: 0 12px;
      padding: 12px 0;
      .sku_flex {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .sku_item {
          padding: 6px 8px;
          border-radius: 2px;
          border: 1px solid #000;
          margin: 12px 8px 0 0;
        }
      }
    }
    .sku_num {
      margin: 24px 12px 0;
      display: flex;
      .mr_right {
        margin-right: 24px;
      }
    }
  }
  .bottom_btn {
    background: #fff;
    margin: 0 12px;
    padding-bottom: 7px;
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    .add_car {
      border-radius: 21px;
      border: 1px solid #000;
      padding: 11px 52px;
    }
    .none_add {
      border-radius: 21px;
      border: 1px solid rgba(0, 0, 0, 0.25);
      padding: 11px 52px;
      background: rgba(0, 0, 0, 0.25);
      border-radius: 21px;
      color: #fff;
    }
    .go_now {
      background: linear-gradient(90deg, #e8caa1 0%, #bf9264 100%);
      border-radius: 21px;
      padding: 12px 52px;
    }
  }
  .bottom_btn1 {
    background: #fff;
    padding-bottom: 7px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    .btn {
      border-radius: 21px;
      background: linear-gradient(90deg, #e8caa1 0%, #bf9264 100%);
      padding: 12px 0;
      margin: 0 12px;
    }
  }
  ::v-deep .van-action-sheet {
    max-height: 100%;
  }
  ::v-deep .van-popup--bottom {
    // top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    top: 0;
  }
  ::v-deep .van-stepper__plus {
    background-color: #fff;
  }
  ::v-deep .van-stepper__minus {
    background-color: #fff;
  }
  ::v-deep .van-sku-messages {
    padding-bottom: 60px;
  }
  ::v-deep .van-sku-container {
    height: 100%;
    max-height: 100%;
  }
}
.num_none {
  ::v-deep .van-sku-stepper-stock {
    display: none;
  }
}
</style>
